/**
 * Function to generate compile-time errors in non-exhaustive switch cases.
 * @param x the type
 */
export function assertNever(x: never): never {
    throw new Error('Unexpected object: ' + x);
}
